import * as React from "react";
import { useState, useEffect } from "react";
import PublicLayout from "../components/PublicLayout";
import PublicHeader from "../components/PublicHeader";
import calendarIcon from "../assets/icons/calendar.svg";
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  const manageData = () => {
    navigate('/gestioneprivacy')
  }

  return (
    <>
      <PublicLayout>
        <Box 
          display="flex" 
          flexDirection="column" 
          alignItems="flex-start"
          width="98%"
        >
          <PublicHeader />

          <Box 
            display="flex" 
            flexDirection="column" 
            alignItems="left" 
            p="20px"
            height="calc(100% - 80px)"
          >
            <Box 
              display="flex" 
              flexDirection="column" 
              alignItems="left" 
              p="20px"
              sx={{
                overflow: "auto", 
              }}
            >
              <Box 
                display="flex" 
                flexDirection="row" 
                alignItems="center" 
              >
                <img
                    src={calendarIcon}
                    style={{
                        display: "flex",
                        height: 32,
                        width: 32,
                        marginTop: "5px"
                    }}
                />
                <Typography
                  sx={{
                    flexGrow: 1,
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 400,
                    fontSize: 20,
                    lineHeight: "100%",
                    letterSpacing: "-0.04em",
                    color: "#0C0D0E",
                  }}
                >
                  Ultimo aggiornamento: 15.10.2025
                </Typography>

                <button
                    className={`m-1 rounded-2 btn btn-dark`}
                    onClick={() => manageData()}
                >
                    Gestisci i tuoi dati
                </button>
              </Box>


              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 700,
                  fontSize: 48,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                Privacy Policy - Applicazione mobile “Nimbleness”
              </Typography>

              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                La presente informativa, redatta ai sensi degli articoli 13 e 14 del Regolamento (UE) 2016/679 (“GDPR”) e del D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018, ha lo scopo di illustrare in modo chiaro e trasparente le modalità con cui vengono raccolti e trattati i dati personali degli utenti che utilizzano l’applicazione mobile Nimbleness (di seguito anche “App”).<br/>
                L’App è destinata esclusivamente a utenti privati e consente di svolgere sessioni di esercizi fisici con il supporto di un sistema di analisi automatica del movimento corporeo.<br/>
                Il Titolare del trattamento dei dati personali è il Sig. Alessio Cencini via gioviano pontano 63, Spoleto Pg e-mail di contatto per ogni richiesta relativa alla protezione dei dati personali: privacy@nimbleness.it<br/>
                L’applicazione è stata sviluppata per il progetto “Officine del Movimento” e i contenuti di questa informativa si applicano esclusivamente all’uso dell’app Nimbleness per dispositivi mobili iOS e Android.
              </Typography>


              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                1. Tipologia di dati trattati e modalità di raccolta
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                L’utilizzo dell’app richiede la registrazione dell’utente, mediante l’inserimento di un indirizzo e-mail, una password e il proprio nome. Tali dati vengono memorizzati all’interno del sistema per consentire l’autenticazione e l’accesso all’applicazione.<br/>
                Nel corso delle sessioni di allenamento, l’app raccoglie temporaneamente le coordinate relative alla posa del corpo e il video dell’esercizio eseguito, ripreso attraverso la fotocamera del dispositivo. I punti di riferimento vengono inviati al server per consentire al sistema di elaborare le metriche di valutazione del movimento e restituire all’app un punteggio sintetico da 1 a 5.<br/>
                Nelle sessioni denominate “Fisio-Coach”, l’app genera inoltre un file di testo contenente gli “score” di ciascun esercizio. Tale file viene salvato localmente sul dispositivo dell’utente ed è utilizzato esclusivamente per finalità di debug o miglioramento delle prestazioni. Nessuno di questi dati viene memorizzato nei server o nel backoffice del Titolare, ad eccezione delle credenziali di login (e-mail e data di registrazione) visibili al personale autorizzato tramite il portale di amministrazione.<br/>
                Non sono raccolti dati di pagamento, dati sensibili, biometrici o relativi alla geolocalizzazione, né log di utilizzo o preferenze di comportamento. L’app non utilizza cookie né strumenti di tracciamento.
              </Typography>


              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                2. Finalità e basi giuridiche del trattamento
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                I dati personali dell’utente sono trattati esclusivamente per le seguenti finalità:<br/>
                <ul>
                <li>Gestione della registrazione e dell’accesso all’applicazione, sulla base dell’art. 6, par. 1, lett. b) GDPR (esecuzione di un contratto o di misure precontrattuali);</li>
                <li>Esecuzione delle funzioni tecniche dell’app, ossia l’analisi del movimento corporeo e la restituzione del punteggio di correttezza, con base giuridica nel medesimo articolo;</li>
                <li>Gestione del corretto funzionamento e della sicurezza del sistema, ai sensi dell’art. 6, par. 1, lett. f) GDPR (legittimo interesse del Titolare a garantire la sicurezza informatica e la manutenzione del sistema);</li>
                <li>Accesso alla fotocamera e registrazione video, per la quale è richiesto il consenso esplicito dell’utente, necessario al corretto funzionamento dell’applicazione.</li>
                </ul>
                Non vengono effettuati trattamenti per finalità di marketing, profilazione o comunicazioni commerciali.
              </Typography>


              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                3. Modalità del trattamento<br/>
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                I dati personali sono trattati prevalentemente con strumenti elettronici, nel rispetto dei principi di liceità, correttezza, trasparenza e minimizzazione. Le operazioni di trattamento sono limitate a quanto strettamente necessario per il funzionamento dell’app.<br/>
Le comunicazioni tra l’app, il server e il gestionale avvengono attraverso protocolli cifrati HTTPS/SSL. Il web server è configurato con certificato di sicurezza digitale e puntamento DNS dedicato.<br/>
I dati raccolti vengono salvati nei sistemi del Titolare solo nella misura minima indispensabile (indirizzo e-mail e data di registrazione). Tutte le altre informazioni generate durante l’utilizzo vengono elaborate in tempo reale e, al termine della sessione, non vengono conservate né archiviate nei server o in altri sistemi gestiti dal Titolare.<br/>
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                4. Natura obbligatoria o facoltativa del conferimento dei dati<br/>
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                Il conferimento dei dati richiesti al momento della registrazione (nome, e-mail, password) è obbligatorio, poiché necessario per consentire la creazione dell’account e l’accesso all’applicazione. Il mancato conferimento di tali dati comporta l’impossibilità di utilizzare l’app.<br/>
Il consenso all’utilizzo della fotocamera e alla registrazione video è anch’esso indispensabile per poter usufruire delle funzionalità di analisi del movimento. Tutti gli altri trattamenti (che non implicano dati personali) sono tecnicamente necessari e non soggetti a consenso.
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                5. Sicurezza dei dati<br/>
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                Il Titolare adotta misure tecniche e organizzative idonee a garantire la sicurezza dei dati personali, comprese configurazioni protette dei server, certificati SSL, restrizione degli accessi al backoffice e audit periodici. L’hosting dell’applicazione è affidato ad Aruba S.p.A., con server collocati all’interno dell’Unione Europea.<br/>
I dati di autenticazione sono custoditi su server sicuri e protetti da accesso non autorizzato, sebbene attualmente non sia implementata una cifratura delle password nel database. Tale aspetto potrà essere oggetto di successivi miglioramenti tecnici, in linea con l’evoluzione dell’app.<br/>
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                6. Comunicazione e diffusione dei dati<br/>
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                I dati personali non sono comunicati a soggetti terzi né diffusi in alcun modo. Possono essere trattati esclusivamente dal personale tecnico incaricato e autorizzato dal Titolare, che accede al portale backoffice per finalità di amministrazione e manutenzione del sistema.<br/>
Non è previsto alcun trasferimento di dati personali al di fuori dello Spazio Economico Europeo.
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                7. Conservazione dei dati<br/>
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                I dati di registrazione (e-mail e data di creazione account) vengono conservati per l’intera durata dell’utilizzo dell’app e cancellati su richiesta dell’utente o in caso di disattivazione dell’account.<br/>
Tutti i dati generati durante le sessioni di allenamento vengono elaborati in tempo reale e cancellati automaticamente al termine della sessione. I file di testo generati in modalità “Fisio-Coach” rimangono memorizzati unicamente sul dispositivo dell’utente e non sono accessibili al Titolare o a soggetti terzi.<br/>
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                8. Diritti dell’interessato
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                L’utente può esercitare in qualsiasi momento i diritti riconosciuti dagli articoli 15-22 del GDPR, tra cui:<br/>
<ul>
<li>ottenere conferma che sia o meno in corso un trattamento di dati personali che lo riguarda;</li>
<li>accedere ai propri dati e riceverne copia;</li>
<li>richiederne la rettifica o la cancellazione (“diritto all’oblio”);</li>
<li>ottenere la limitazione del trattamento;</li>
<li>opporsi per motivi legittimi al trattamento dei dati;</li>
<li>richiedere la portabilità dei dati forniti in formato strutturato.</li>
</ul>
L’utente può inoltre revocare in qualsiasi momento il consenso concesso per l’utilizzo della fotocamera, ferma restando la liceità del trattamento effettuato prima della revoca.<br/>
Per esercitare i propri diritti o chiedere la cancellazione dei dati di registrazione, è possibile inviare una richiesta scritta all’indirizzo e-mail privacy@nimbleness.it o cliccare il link ipertestuale “Privacy Policy” disponibile nella sezione di Login dell’app, che rinvia ad una pagina dalla quale è possibile la gestione delle richieste.<br/><br/>
Qualora l’utente ritenga che il trattamento dei dati violi le disposizioni del GDPR, può proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                9. Processi automatizzati e profilazione<br/>
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                Nell’ambito dell’app Nimbleness non vengono effettuati processi decisionali automatizzati né attività di profilazione in grado di produrre effetti giuridici o significativi sull’interessato ai sensi dell’art. 22 del GDPR.
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                10. Minori
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                L’app può essere utilizzata anche da utenti minorenni sotto la supervisione di un adulto. Tuttavia, il Titolare non raccoglie intenzionalmente dati personali di minori di anni quattordici e invita i genitori o i tutori legali a vigilare sull’utilizzo dell’app.<br/>
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: 30,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "20px"
                }}
              >
                11. Aggiornamenti e modifiche<br/>
              </Typography>
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                Il Titolare si riserva il diritto di modificare in qualsiasi momento la presente informativa per adeguarla ad aggiornamenti normativi o a evoluzioni tecniche dell’applicazione. Le modifiche verranno comunicate agli utenti tramite e-mail all’indirizzo fornito in fase di registrazione e saranno immediatamente visibili nella sezione “Privacy Policy” accessibile dalla schermata di login.<br/>
              </Typography>

              
              <Typography
                sx={{
                  width: "100%",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: 18,
                  lineHeight: "100%",
                  letterSpacing: "-0.04em",
                  color: "#1C492D",
                  mt: "10px"
                }}
              >
                Titolare del trattamento: Alessio Cencini<br/>
                Email: virtuale@nimbleness.it<br/>
                Recapito postale: Virtuale srls via gioviano pontano 63, Spoleto Pg<br/>
              </Typography>
            </Box>
            
          </Box>
        </Box>
      </PublicLayout>

    </>
  );
};

export default PrivacyPolicy;

